import React, { useState } from "react";
import Input from "../../Input";
import kfu from "../../../assets/kfu-iuef.png";
import kimaAdmin from "../../../assets/kima_admin.png";

// api
import AuthApi from "../auth.api";
import ProfileApi from "../../../pages/Profile/profile.api";

// Miscellaneous
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { LoadToTop } from "../../../utils";
import { toast } from "react-hot-toast";
import { Icon } from "@iconify/react";

const LoginAdmin = ({ title }) => {
  const [data, setData] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (data?.email && data?.password) {
        const res = await AuthApi.login(data?.email, data?.password);
        let token = res?.data?.token;
        if (res?.data?.token) {
          localStorage.setItem("access_token", token);
          const res2 = await ProfileApi.getProfile();
          if (res2?.data?.user?.Role?.id === 1) {
            localStorage.setItem("userData", JSON.stringify(res2?.data?.user));
            navigate("/dashboard");
            LoadToTop();
            toast.success("Добро пожаловать, админ!");
          } else {
            localStorage.removeItem("access_token");
          }
        }
      }
    } catch (err) {
      console.log(err);
      toast.error("Неверный адрес электронной почты или пароль");
    }
  };

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <section className="paddingX xl:paddingXLonger3 bg-customGray2">
        <div className="flex flex-wrap items-center justify-center w-full min-h-screen max-sm:p-0 paddingX">
          <div
            style={{ backgroundImage: `url(${kfu})`, backgroundSize: "cover" }}
            className="max-xl:hidden xl:w-[45%] h-[35rem] lg:h-[40rem] p-6 relative shadow-xl"
          >
            <div className="absolute h-full w-full bg-gradient-to-t from-customBlue from-10% via-customBlue/95 via-10% to-white/75 to-100% left-0 top-0" />
            <div className="relative h-full paddingYLonger">
              <div className="absolute bottom-0 w-full h-full border-4 border-white" />
              <div className="flex flex-col items-center justify-center h-full gap-2">
                <div className="paddingX">
                  <img
                    src={kimaAdmin}
                    alt="KIMA-logo"
                    className="object-cover"
                  />
                </div>
                <p className="text-center text-white pBigger">
                  “Преврати свои знания <br /> в реальные возможности”
                </p>
              </div>
            </div>
          </div>
          <div className="w-full xl:w-[55%] border-t-2 border-r-2 border-b-2 max-xl:border-2 border-customBlue h-[35rem] lg:h-[40rem] shadow-xl">
            <div className="flex flex-col h-full">
              <div className="xl:h-[30%] bg-customBlue xl:paddingYShorter2 xl:paddingXShorter2 xl:paddingTopShorter max-xl:paddingAllEquals">
                <h3 className="text-customYellow ">Добро пожаловать</h3>
                <p className="text-white pBigger">
                  войдите в систему, чтобы продолжить
                </p>
              </div>
              <div className="h-[70%] bg-customGray paddingXShorter paddingTopShorter  paddingBottom max-xl:paddingAllEquals pBigger">
                <div className="grid gap-5">
                  <Input
                    className="rounded-none"
                    name="email"
                    password={data?.email || ""}
                    label="Почта"
                    placeholder="admin@example.com"
                    onChange={handleChange}
                  />
                  <div className="flex flex-col">
                    <label
                      className={`mb-1 ml-1 font-semibold text-customBlue `}
                    >
                      Пароль
                    </label>
                    <div className="relative">
                      <Input
                        className="rounded-none w-full pr-12"
                        name="password"
                        type={showPassword ? "text" : "password"}
                        password={data?.password || ""}
                        placeholder="********"
                        onChange={handleChange}
                      />
                      <div
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute cursor-pointer inset-y-0 right-4 flex items-center"
                      >
                        <Icon icon="zondicons:view-show" width={20} />
                      </div>
                    </div>
                  </div>
                  <button
                    className="px-10 py-2 mx-auto mt-8 font-semibold border-2 w-fit bg-customYellow border-customText"
                    onClick={handleSubmit}
                  >
                    Войти
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LoginAdmin;
